"use strict";
exports.__esModule = true;
exports.fromPolkadotResourcesRaw = exports.toPolkadotResourcesRaw = void 0;
var bignumber_js_1 = require("bignumber.js");
function toPolkadotResourcesRaw(r) {
    var _a, _b;
    var nonce = r.nonce, controller = r.controller, stash = r.stash;
    return {
        controller: controller,
        stash: stash,
        nonce: nonce,
        lockedBalance: r.lockedBalance.toString(),
        unlockedBalance: r.unlockedBalance.toString(),
        unlockingBalance: r.unlockingBalance.toString(),
        unlockings: (_a = r.unlockings) === null || _a === void 0 ? void 0 : _a.map(function (u) { return ({
            amount: u.amount.toString(),
            completionDate: u.completionDate.toISOString()
        }); }),
        nominations: (_b = r.nominations) === null || _b === void 0 ? void 0 : _b.map(function (n) { return ({
            address: n.address,
            value: n.value.toString(),
            status: n.status
        }); }),
        numSlashingSpans: r.numSlashingSpans
    };
}
exports.toPolkadotResourcesRaw = toPolkadotResourcesRaw;
function fromPolkadotResourcesRaw(r) {
    var _a, _b;
    var nonce = r.nonce, controller = r.controller, stash = r.stash;
    return {
        controller: controller,
        stash: stash,
        nonce: nonce,
        lockedBalance: new bignumber_js_1.BigNumber(r.lockedBalance),
        unlockedBalance: new bignumber_js_1.BigNumber(r.unlockedBalance),
        unlockingBalance: new bignumber_js_1.BigNumber(r.unlockingBalance),
        unlockings: (_a = r.unlockings) === null || _a === void 0 ? void 0 : _a.map(function (u) { return ({
            amount: new bignumber_js_1.BigNumber(u.amount),
            completionDate: new Date(u.completionDate)
        }); }),
        nominations: (_b = r.nominations) === null || _b === void 0 ? void 0 : _b.map(function (n) { return ({
            address: n.address,
            value: new bignumber_js_1.BigNumber(n.value),
            status: n.status
        }); }),
        numSlashingSpans: Number(r.numSlashingSpans) || 0
    };
}
exports.fromPolkadotResourcesRaw = fromPolkadotResourcesRaw;
//# sourceMappingURL=serialization.js.map